import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { MailIcon, MapPinIcon, InstagramIcon, YoutubeIcon, LinkedinIcon, FacebookIcon } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <Layout data-id="element-159">
      <div className="max-w-7xl mx-auto px-6 py-16" data-id="element-160">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-161">
          <h1 className="text-5xl font-bold text-black mb-4" data-id="element-162">Contact Us</h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-163">
            We'd Love to Hear From You
          </p>
          <p className="text-gray-600 mt-4 max-w-3xl mx-auto" data-id="element-164">
            At Voices with Victoria, every connection matters. Whether you have
            a question, a partnership idea, or a story worth sharing, we'd love
            to hear from you. Our team is here to help you connect, collaborate,
            and be part of the movement that's shaping Africa's next generation
            of changemakers.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto" data-id="element-165">
          {/* Contact Information */}
          <div className="space-y-8" data-id="element-166">
            <div data-id="element-167">
              <h2 className="text-2xl font-bold text-black mb-6" data-id="element-168">
                Get in Touch
              </h2>
              <div className="space-y-4" data-id="element-169">
                <div className="flex items-start gap-4 p-4 bg-white rounded-lg shadow-md" data-id="element-170">
                  <MailIcon size={24} className="text-voices-red mt-1" data-id="element-171" />
                  <div data-id="element-172">
                    <h3 className="font-semibold text-black mb-1" data-id="element-173">
                      General Inquiries
                    </h3>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-174">
                      Have questions about Voices with Victoria Live, the
                      podcast, or upcoming events?
                    </p>
                    <a href="mailto:hello@voiceswithvictoria.com" className="text-voices-red hover:text-red-700" data-id="element-175">
                      hello@voiceswithvictoria.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 bg-white rounded-lg shadow-md" data-id="element-176">
                  <MailIcon size={24} className="text-voices-red mt-1" data-id="element-177" />
                  <div data-id="element-178">
                    <h3 className="font-semibold text-black mb-1" data-id="element-179">
                      Partnerships & Collaborations
                    </h3>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-180">
                      Would you like to collaborate, sponsor a season, or
                      partner with us?
                    </p>
                    <a href="mailto:partnerships@voiceswithvictoria.com" className="text-voices-red hover:text-red-700" data-id="element-181">
                      partnerships@voiceswithvictoria.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 bg-white rounded-lg shadow-md" data-id="element-182">
                  <MailIcon size={24} className="text-voices-red mt-1" data-id="element-183" />
                  <div data-id="element-184">
                    <h3 className="font-semibold text-black mb-1" data-id="element-185">
                      Media & Press
                    </h3>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-186">
                      For interviews, media appearances, or press coverage
                    </p>
                    <a href="mailto:media@voiceswithvictoria.com" className="text-voices-red hover:text-red-700" data-id="element-187">
                      media@voiceswithvictoria.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 bg-white rounded-lg shadow-md" data-id="element-188">
                  <MapPinIcon size={24} className="text-voices-red mt-1" data-id="element-189" />
                  <div data-id="element-190">
                    <h3 className="font-semibold text-black mb-1" data-id="element-191">
                      Our Office
                    </h3>
                    <p className="text-gray-600 text-sm" data-id="element-192">
                      Lagos, Nigeria
                      <br data-id="element-193" />
                      Open Monday – Friday, 9:00 AM – 5:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Social Media */}
            <div data-id="element-194">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-195">
                Connect With Us Online
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-196">
                Stay updated, get behind-the-scenes content, and join the
                conversation.
              </p>
              <div className="flex gap-4" data-id="element-197">
                <a href="https://instagram.com/voiceswithvictoriashow" target="_blank" rel="noopener noreferrer" className="p-3 bg-voices-red text-white rounded-full hover:bg-red-700 transition-colors" data-id="element-198">
                  <InstagramIcon size={24} data-id="element-199" />
                </a>
                <a href="https://youtube.com/@victoriandu" target="_blank" rel="noopener noreferrer" className="p-3 bg-voices-red text-white rounded-full hover:bg-red-700 transition-colors" data-id="element-200">
                  <YoutubeIcon size={24} data-id="element-201" />
                </a>
                <a href="https://www.linkedin.com/in/victorianwanna/" target="_blank" rel="noopener noreferrer" className="p-3 bg-voices-red text-white rounded-full hover:bg-red-700 transition-colors" data-id="element-202">
                  <LinkedinIcon size={24} data-id="element-203" />
                </a>
                <a href="https://web.facebook.com/victoria.nwanna.5" target="_blank" rel="noopener noreferrer" className="p-3 bg-voices-red text-white rounded-full hover:bg-red-700 transition-colors" data-id="element-204">
                  <FacebookIcon size={24} data-id="element-205" />
                </a>
              </div>
            </div>
          </div>
          {/* Contact Form */}
          <div data-id="element-206">
            <div className="bg-white p-8 rounded-xl shadow-lg border-l-8 border-voices-gold" data-id="element-207">
              <h2 className="text-2xl font-bold text-black mb-2" data-id="element-208">
                Have a Message for Victoria Ndu?
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-209">
                If you'd like to send a personal note, invite Victoria to speak,
                or share how Voices with Victoria has inspired you, kindly fill
                out the form below — our team will get back to you soon.
              </p>
              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-210">
                <div data-id="element-211">
                  <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-212">
                    Name
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-voices-red focus:border-voices-red" placeholder="Your name" data-id="element-213" />
                </div>
                <div data-id="element-214">
                  <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-215">
                    Email
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-voices-red focus:border-voices-red" placeholder="your.email@example.com" data-id="element-216" />
                </div>
                <div data-id="element-217">
                  <label htmlFor="subject" className="block text-gray-700 font-medium mb-2" data-id="element-218">
                    Subject
                  </label>
                  <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-voices-red focus:border-voices-red" placeholder="What is this about?" data-id="element-219" />
                </div>
                <div data-id="element-220">
                  <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-221">
                    Message
                  </label>
                  <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-voices-red focus:border-voices-red" placeholder="Your message..." data-id="element-222"></textarea>
                </div>
                <button type="submit" className="w-full bg-voices-red text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors" data-id="element-223">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
        {/* Bottom CTA */}
        <div className="mt-16 bg-gradient-to-br from-voices-red to-red-700 text-white rounded-2xl p-12 text-center max-w-4xl mx-auto" data-id="element-224">
          <h2 className="text-3xl font-bold mb-4" data-id="element-225">
            Let's Keep the Conversation Going
          </h2>
          <p className="text-xl" data-id="element-226">
            At Voices with Victoria, we believe every great story starts with a
            conversation. Reach out — and let's create something impactful
            together.
          </p>
        </div>
      </div>
    </Layout>;
}